module.exports = __webpack_public_path__ + "static/media/01_f_photo.7b000523.png";